
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CanadaEnV extends Vue {
    scrollTo(id: string) {
        const el = document.querySelector(`#${id}`) as HTMLElement;

        window.scrollTo(0, el.offsetTop);
    }
}
